import React, { useState, useEffect } from 'react';
import { FaSpinner, FaTimes } from 'react-icons/fa';
import projectService from '../../services/projectService';
import '../FileManager/PdfViewerModal.css';

const TaskAttachmentPdfViewerModal = ({ taskId, attachment, onClose }) => {
    const [viewUrl, setViewUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchViewUrl = async () => {
            if (!taskId || !attachment?.id) {
                setError('No file provided');
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                const res = await projectService.getAttachmentViewUrl(taskId, attachment.id);
                if (res?.status && res?.data?.url) {
                    setViewUrl(res.data.url);
                } else {
                    setError('Failed to load PDF');
                }
            } catch (err) {
                setError(err.message || 'Failed to load PDF');
            } finally {
                setLoading(false);
            }
        };

        fetchViewUrl();
    }, [taskId, attachment]);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!attachment) return null;

    const title = attachment.upload?.original_filename || attachment.upload?.name || 'PDF Document';

    return (
        <div className="pdf-viewer-overlay" onClick={handleBackdropClick}>
            <div className="pdf-viewer-modal">
                <div className="pdf-viewer-header">
                    <h3 className="pdf-viewer-title">{title}</h3>
                    <button
                        className="pdf-viewer-close"
                        onClick={onClose}
                        aria-label="Close PDF viewer"
                    >
                        <FaTimes />
                    </button>
                </div>
                <div className="pdf-viewer-content">
                    {loading && (
                        <div className="pdf-viewer-loading">
                            <FaSpinner className="pdf-viewer-spinner" />
                            <p>Loading PDF...</p>
                        </div>
                    )}
                    {error && !loading && (
                        <div className="pdf-viewer-error">
                            <p>{error}</p>
                            <button onClick={onClose}>Close</button>
                        </div>
                    )}
                    {!loading && !error && viewUrl && (
                        <iframe
                            src={viewUrl}
                            className="pdf-viewer-iframe"
                            title={title}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default TaskAttachmentPdfViewerModal;
